// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Y_s"};